import CompanyDetailsCard from "../Component/CompanyProfile/CompanyDetailsCard";
import CompanySocialAccountsCard from "../Component/CompanyProfile/CompanySocialAccountsCard";
import CompanyInformationCard from "../Component/CompanyProfile/CompanyInformationCard";
import Meta from "../../../../custom-ui/meta/Meta";
import { requireAuth, useAuth } from "../../../../../providers/auth";
import { useEmployer } from "../../../../../data/employer";

type Props = {};

const CompanyProfile_NewUI = (props: Props) => {
  const { user } = useAuth()
  const { data } = useEmployer(user?.claims?.employerId || "")
  const askUserToAddCpInfo  = (!data?.location||!data?.logo||!data?.profile?.url)?true:false
  return (
    <>
      <Meta title="Company Profile" />
      <div className="flex flex-col">
        <p className="text-[#15415E] font-[Gilroy-Bold] font-[400] text-[32px] leading-[39.62px]">
          Company Profile
        </p>
        {askUserToAddCpInfo&&<div className="mt-2 py-4 rounded-lg px-4 w-full opacity-80 bg-[#f5bab3] ">
          <p className="text-red-600 font-[500]">Please add Company Logo, Company Details and Company Information</p>
        </div>}
        <div className="flex flex-row lg:flex-col md:flex-col mt-[50px] gap-[30px]">
          <CompanyDetailsCard />
          <div className="flex flex-col w-1/2 md:w-full lg:w-full gap-y-[20px]">
            <CompanySocialAccountsCard />
            <CompanyInformationCard />
          </div>
        </div>
      </div>
    </>
  );
};

export default  requireAuth(CompanyProfile_NewUI);
